import React, { useState, useEffect } from 'react'
import {
    Grid,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Typography,
    Backdrop,
    CircularProgress,
} from "@material-ui/core";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import PageTitle from "../../components/PageTitle";
import { toast } from "react-toastify";
import Notification from "../../components/Notification";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import { useHistory } from "react-router-dom";

const positions = [toast.POSITION.TOP_RIGHT];

const RecCoinWidrawPage = () => {

    const classes = useStyles();
    const token = localStorage.getItem("token");
    const [loader, setLoader] = useState(false);
    var [notificationsPosition] = useState(2);
    var [errorToastId, setErrorToastId] = useState(null);
    const [isBankDetailsExist, setIsBankDetailsExist] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const isBankDetailsAlreadyExist = localStorage.getItem("isBankDetailsAvailable");
        if (isBankDetailsAlreadyExist) {
            setIsBankDetailsExist(JSON.parse(isBankDetailsAlreadyExist))
        }
    }, []);

    useEffect(() => {
        async function getBankDetails() {
            setLoader(true);
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER}recruiter/getBankDetails`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: token,
                        },
                    }
                );
                setLoader(false);

                if (response.data.status === true) {
                    if (response.data.data.bankName !== "") {
                        setBankDetailsEdit("bankName", response.data.data.bankName);
                        setBankDetailsEdit("accountNumber", response.data.data.accountNumber);
                        setBankDetailsEdit("ifscCode", response.data.data.ifscCode);
                        setBankDetailsEdit("micrCode", response.data.data.micrCode);
                        setBankDetailsEdit("gstNumber", response.data.data.gstNumber);
                        setBankDetailsEdit("panNumber", response.data.data.panNumber);
                    }
                }
                else {
                    localStorage.setItem("isBankDetailsAvailable", JSON.stringify(false));
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        }

        getBankDetails()
    }, []);

    function sendNotification(componentProps, options) {
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options,
        );
    }

    function handleNotificationCall(notificationType, message) {
        var componentProps;

        if (errorToastId && notificationType === "error") return;

        switch (notificationType) {
            case "info":
                componentProps = {
                    type: "feedback",
                    message: message,
                    variant: "contained",
                    color: "primary",
                };
                break;
            case "error":
                componentProps = {
                    type: "message",
                    message: message,
                    variant: "contained",
                    color: "secondary",
                };
                break;
            default:
                componentProps = {
                    type: "shipped",
                    message: message,
                    variant: "contained",
                    color: "success",
                };
        }

        var toastId = sendNotification(componentProps, {
            type: notificationType,
            position: positions[notificationsPosition],
            progressClassName: classes.progress,
            onClose: notificationType === "error" && (() => setErrorToastId(null)),
            className: classes.notification,
        });

        if (notificationType === "error") setErrorToastId(toastId);
    }

    const validationSchema = Yup.object().shape({
        bankName: Yup.string()
            .required("Bank Name is required"),
        accountNumber: Yup.string()
            .required("Your Account Number is required"),
        ifscCode: Yup.string().when('micrCode', {
            is: val => !val, // Only validate if micrCode is empty
            then: Yup.string().required("Either IFSC code or MICR code is required")
        }),
        micrCode: Yup.string(),
        gstNumber: Yup.string(),
        panNumber: Yup.string().max(255).required("PAN Number is required"),
    })

    const {
        register,
        reset,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const {
        register: editBankDetails,
        formState: { errors: editErrors, isSubmitting: editIsSubmitting },
        setValue: setBankDetailsEdit,
        handleSubmit: editSubmit,
        reset: editreset,
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    })

    async function handleAddBankDetails(values) {
        setLoader(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER}recruiter/addBankDetails`,
                values,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                }
            );
            setLoader(false);
            if (response.data.status === true) {
                handleNotificationCall("success", response.data.message);
                localStorage.setItem("isBankDetailsAvailable", JSON.stringify(true));
                history.push("/app/dashboard");
            } else {
                handleNotificationCall("error", response.data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    async function handleEditBankDetails(values) {
        setLoader(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER}recruiter/editBankDetails`,
                values,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                }
            );
            setLoader(false);

            console.log(response)
            if (response.data.status === true) {
                handleNotificationCall("success", response.data.message);
                history.push("/app/dashboard");
            } else {
                handleNotificationCall("error", response.data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    return (
        <Grid
            container
            direction="row"
            spacing={1}
        >
            <Grid item xs={12}>
                <PageTitle title={!isBankDetailsExist ? "Add Bank Details" : "Edit Bank Details"} />
            </Grid>
            <Grid item xs={12} lg={8} style={{ marginTop: '15px' }}>
                {!isBankDetailsExist ? (
                    <form onSubmit={handleSubmit(handleAddBankDetails)}>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                        >
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="bankName">
                                    Bank Name
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        InputProps={{ disableUnderline: true }}
                                        classes={{ root: classes.customTextField }}
                                        size="small"
                                        placeholder="Enter Your Bank Name"
                                        id="bankName"
                                        {...register("bankName")}
                                        error={errors.bankName ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.bankName?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="accountNumber">
                                    Account Number
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter Account Number Carefully"
                                        id="accountNumber"
                                        {...register("accountNumber")}
                                        error={errors.accountNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.accountNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="ifscCode">
                                    IFSC Code
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter your branch IFSC Code"
                                        id="ifscCode"
                                        {...register("ifscCode")}
                                        error={errors.ifscCode ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.ifscCode?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="micrCode">
                                    MICR Code
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        type="text"
                                        placeholder="Enter your branch MICR Code"
                                        id="micrCode"
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        {...register("micrCode")}
                                        error={errors.micrCode ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.micrCode?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="gstNumber">
                                    GST Number (optional)
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        type="text"
                                        placeholder="Enter your GST Number"
                                        id="gstNumber"
                                        {...register("gstNumber")}
                                        error={errors.gstNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.gstNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="panNumber">
                                    PAN Number
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter PAN Number"
                                        id="panNumber"
                                        {...register("panNumber")}
                                        error={errors.panNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {errors.panNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                            justifyContent="flex-end"
                            style={{ padding: '15px 3px' }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </form>
                ) : (
                    <form onSubmit={editSubmit(handleEditBankDetails)}>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                        >
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="bankName">
                                    Bank Name
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        InputProps={{ disableUnderline: true }}
                                        classes={{ root: classes.customTextField }}
                                        size="small"
                                        placeholder="Enter Your Bank Name"
                                        id="bankName"
                                        {...editBankDetails("bankName")}
                                        error={editErrors.bankName ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.bankName?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="accountNumber">
                                    Account Number
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter Account Number Carefully"
                                        id="accountNumber"
                                        {...editBankDetails("accountNumber")}
                                        error={editErrors.accountNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.accountNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="ifscCode">
                                    IFSC Code
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter your branch IFSC Code"
                                        id="ifscCode"
                                        {...editBankDetails("ifscCode")}
                                        error={editErrors.ifscCode ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.ifscCode?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="micrCode">
                                    MICR Code
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        type="text"
                                        placeholder="Enter your branch MICR Code"
                                        id="micrCode"
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        {...editBankDetails("micrCode")}
                                        error={editErrors.micrCode ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.micrCode?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="gstNumber">
                                    GST Number (optional)
                                </InputLabel>

                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        type="text"
                                        placeholder="Enter your GST Number"
                                        id="gstNumber"
                                        {...editBankDetails("gstNumber")}
                                        error={editErrors.gstNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.gstNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <InputLabel shrink htmlFor="panNumber">
                                    PAN Number
                                </InputLabel>
                                <FormControl className={classes.margin}>
                                    <TextField
                                        classes={{ root: classes.customTextField }}
                                        InputProps={{ disableUnderline: true }}
                                        size="small"
                                        placeholder="Enter PAN Number"
                                        id="panNumber"
                                        {...editBankDetails("panNumber")}
                                        error={editErrors.panNumber ? true : false}
                                    />

                                    <Typography variant="inherit" color="error">
                                        {editErrors.panNumber?.message}
                                    </Typography>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                            justifyContent="flex-end"
                            style={{ padding: '15px 3px' }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                type="submit"
                                disabled={editIsSubmitting}
                            >
                                Edit
                            </Button>

                        </Grid>
                    </form>
                )}

            </Grid>
            <Grid item xs={12} lg={4}>

            </Grid>

            <Backdrop className={classes.backdrop} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>

        </Grid>


    )
}

export default RecCoinWidrawPage